module.exports = __webpack_public_path__ + "29b0065adc088c2eadd65e415c84d988.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-basic-4.png
// module id = 1562
// module chunks = 0